// Which shell overlay is open: the command palette or the shortcuts dialog. A store outside React
// so that shortcuts and palette commands can open them.
import { useSyncExternalStore } from "react";

export type Overlay = "palette" | "shortcuts" | null;

let open: Overlay = null;
const listeners = new Set<() => void>();

export function setOverlay(overlay: Overlay): void {
  open = overlay;
  for (const listener of listeners) listener();
}

/** Opens an overlay, or closes it when it is already open. */
export const toggleOverlay = (overlay: Exclude<Overlay, null>): void =>
  setOverlay(open === overlay ? null : overlay);

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export const useOverlay = (): Overlay => useSyncExternalStore(subscribe, () => open);
